'use strict';

const { CLASSES } = require('friartux/utils/globals');
const createErrorNotification = require('friartux/components/errorNotification');

const SELECTORS = {
    body: 'body',
    customerImageContainer: '.js-customer-image',
    errorMessage: '.error-messaging',
    fileUploaderContainer: '.js-replica-uploader',
    viewerTab: '.js-viewer-tab',
    feedbackTab: '.js-feedback-tab',
    feedbackBtn: '.js-feedback-btn',
    feedbackButtons: '.js-feedback-buttons',
    feedbackSubmitMessage: '.js-feedback-submit-message',
    feedbackInputContainer: '.js-feedback-input-container',
    feedbackInput: '.js-feedback-input',
    feedbackRating: '.js-feedback-rating',
    feedbackSubmit: '.js-submit-feedback',
    feedbackText: '.js-feedback-text',
    feedbackTextNegativeLabel: '.js-feedback-label-negative',
    tryonModalBox: '.js-aitryon-modal .try-ai__box',
    thankYouMsg: '.js-thank-you-msg',
    thankYouMsgNegative: '.js-thank-you-msg-negative'
};

function init() {
    $(SELECTORS.body).on('click', SELECTORS.feedbackBtn, handleFeedbackNewBtn);
    $(SELECTORS.body).on('click', SELECTORS.feedbackSubmit, handleSubmitFeedback);

    $(SELECTORS.body).on('feedback:reset', function () {
        $(SELECTORS.thankYouMsgNegative).addClass(CLASSES.hide);
        resetFeedback();
    })
}

const handleFeedbackNewBtn = (e) => {
    let $this = $(e.currentTarget);
    let rating = $this.data('value');
    let activeImg = $this.find('.active-img');

    $this.addClass(CLASSES.selected);
    if (activeImg.length > 0) {
        $this.find('img:not(.active-img)').addClass(CLASSES.hide);
        activeImg.removeClass(CLASSES.hide);
    }

    $(SELECTORS.feedbackRating).val(rating);
    $(SELECTORS.thankYouMsgNegative).addClass(CLASSES.hide);
    $(SELECTORS.thankYouMsg).addClass(CLASSES.hide);

    if (rating <= 1) {
        $(SELECTORS.feedbackTextNegativeLabel).removeClass(CLASSES.hide);
        $(SELECTORS.feedbackInputContainer)
            .removeClass(CLASSES.hide)
            .addClass(CLASSES.flex);
        let $tryonModalBox = $(SELECTORS.tryonModalBox);
        $tryonModalBox.animate({
            scrollTop: $tryonModalBox.prop('scrollHeight')
        }, 'fast', () => {
            $(SELECTORS.feedbackInput).trigger('focus');
        });
        $(SELECTORS.thankYouMsgNegative).removeClass(CLASSES.hide);
    } else {
        $(SELECTORS.feedbackButtons).addClass(CLASSES.hide);
        $(SELECTORS.feedbackSubmit).trigger('click');
        $(SELECTORS.thankYouMsg).removeClass(CLASSES.hide);
    }
}

const handleSubmitFeedback = () => {
    let $feedbackButtons = $(SELECTORS.feedbackButtons);
    let $customerImageContainer = $(SELECTORS.customerImageContainer);
    let $feedbackTab = $(SELECTORS.feedbackTab);
    let sourceImg = $customerImageContainer.data('customer-image');
    let token = $customerImageContainer.data('token-value');
    let pid = $(SELECTORS.fileUploaderContainer).data('pid');
    let outputImg = $(SELECTORS.viewerTab).find('img').first().attr('src');
    let rating = $(SELECTORS.feedbackRating).val();
    let feedbackText = $(SELECTORS.feedbackInput).val();
    let generationId = $customerImageContainer.data('generation-id');
    let source = $feedbackButtons.data('source');

    let formData = {
        'pid': pid,
        'rating': rating,
        'feedback': encodeURIComponent(feedbackText),
        'sourceImg': encodeURIComponent(sourceImg),
        'outputImg': encodeURIComponent(outputImg),
        'csrf_token': token,
        'generationId': generationId,
        'source': source
    }

    $.ajax({
        url: $(SELECTORS.feedbackButtons).data('submit-feedback-url'),
        type: 'POST',
        dataType: 'json',
        data: formData,
        success: function (data) {
            if (data.success) {
                if (data.error) {
                    createErrorNotification($(SELECTORS.errorMessage), data.errorMessage);
                } else {
                    showThankYouMessage();
                    setTimeout(() => {
                        resetFeedback();
                    }, 5000);
                }
            } else {
                createErrorNotification($(SELECTORS.errorMessage), data.errorMessage);
                $feedbackTab.spinner().stop();
            }
        },
        error: function (err) {
            createErrorNotification($(SELECTORS.errorMessage), err.responseJSON.errorMessage);

            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            }

            $feedbackTab.spinner().stop();
        }
    });
}

function showThankYouMessage() {
    $(SELECTORS.feedbackButtons).addClass(CLASSES.hide);
    $(SELECTORS.feedbackInputContainer).removeClass(CLASSES.flex).addClass(CLASSES.hide);
    $(SELECTORS.feedbackText).addClass(CLASSES.hide);
    $(SELECTORS.feedbackSubmitMessage).removeClass(CLASSES.hide)
    $(SELECTORS.feedbackTextNegativeLabel).addClass(CLASSES.hide);
    $(SELECTORS.feedbackBtn).removeClass(CLASSES.selected);
    $(SELECTORS.feedbackInput).val(' ').trigger('change');
}

function resetFeedback() {
    let negativeFeedback = !$(SELECTORS.thankYouMsgNegative).hasClass(CLASSES.hide);
    if (!negativeFeedback) {
        $(SELECTORS.feedbackTab).addClass(CLASSES.hide);
        $(SELECTORS.feedbackButtons).removeClass(CLASSES.hide);
        $(SELECTORS.feedbackText).removeClass(CLASSES.hide);
        $(SELECTORS.thankYouMsg).addClass(CLASSES.hide);
        $(SELECTORS.feedbackSubmitMessage).addClass(CLASSES.hide);
    }

    $(SELECTORS.feedbackInput).val('').trigger('change');
    $(SELECTORS.feedbackButtons)
        .find('img:not(.active-img)').removeClass(CLASSES.hide);
    $(SELECTORS.feedbackButtons)
        .find('img.active-img').addClass(CLASSES.hide);
}

module.exports = {
    init: init
};
